"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOOSTER_USER_OFFERS_ECRED = exports.BOOSTER_USER_OFFERS_LIMPA_NOME = exports.BOOSTER_USER_MOTIVATION = exports.BOOSTER_USER_SCORE = exports.BOOSTER_USER_DEBTS = exports.BOOSTER_USER_CREDIT = exports.BOOSTER_USER_COMPANY = exports.BOOSTER_USER_ADVERTISING = exports.BOOSTER_USER_DATA_CREDIT = exports.BOOSTER_USER_SIGNUP = exports.BOOSTER_USER = exports.BOOSTER_PAGEVIEW = exports.BOOSTER_GA = exports.BOOSTER_GTM = void 0;
var BOOSTER_GTM = 'BOOSTER_GTM';
exports.BOOSTER_GTM = BOOSTER_GTM;
var BOOSTER_GA = 'BOOSTER_GA';
exports.BOOSTER_GA = BOOSTER_GA;
var BOOSTER_PAGEVIEW = 'BOOSTER_PAGEVIEW';
exports.BOOSTER_PAGEVIEW = BOOSTER_PAGEVIEW;
var BOOSTER_USER = 'BOOSTER_USER';
exports.BOOSTER_USER = BOOSTER_USER;
var BOOSTER_USER_SIGNUP = 'BOOSTER_USER_SIGNUP';
exports.BOOSTER_USER_SIGNUP = BOOSTER_USER_SIGNUP;
var BOOSTER_USER_DATA_CREDIT = 'BOOSTER_USER_DATA_CREDIT';
exports.BOOSTER_USER_DATA_CREDIT = BOOSTER_USER_DATA_CREDIT;
var BOOSTER_USER_ADVERTISING = 'BOOSTER_USER_ADVERTISING';
exports.BOOSTER_USER_ADVERTISING = BOOSTER_USER_ADVERTISING;
var BOOSTER_USER_COMPANY = 'BOOSTER_USER_COMPANY';
exports.BOOSTER_USER_COMPANY = BOOSTER_USER_COMPANY;
var BOOSTER_USER_CREDIT = 'BOOSTER_USER_CREDIT';
exports.BOOSTER_USER_CREDIT = BOOSTER_USER_CREDIT;
var BOOSTER_USER_DEBTS = 'BOOSTER_USER_DEBTS';
exports.BOOSTER_USER_DEBTS = BOOSTER_USER_DEBTS;
var BOOSTER_USER_SCORE = 'BOOSTER_USER_SCORE';
exports.BOOSTER_USER_SCORE = BOOSTER_USER_SCORE;
var BOOSTER_USER_MOTIVATION = 'BOOSTER_USER_MOTIVATION';
exports.BOOSTER_USER_MOTIVATION = BOOSTER_USER_MOTIVATION;
var BOOSTER_USER_OFFERS_LIMPA_NOME = 'BOOSTER_USER_OFFERS_LIMPA_NOME';
exports.BOOSTER_USER_OFFERS_LIMPA_NOME = BOOSTER_USER_OFFERS_LIMPA_NOME;
var BOOSTER_USER_OFFERS_ECRED = 'BOOSTER_USER_OFFERS_ECRED';
exports.BOOSTER_USER_OFFERS_ECRED = BOOSTER_USER_OFFERS_ECRED;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/booster/build/types.js
// module id = 69
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38